// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as SectionHeading$PorterinFeature from "../../../../ui/components/SectionHeading.mjs";
import * as ServicesCardCmp$PorterinFeature from "../../../../ui/components/ServicesCardCmp.mjs";
import * as ServicesSectionModuleScss from "../styles/ServicesSection.module.scss";

var styles = ServicesSectionModuleScss;

function ServicesSectionCmp(Props) {
  var services_cards_data = Props.services_cards_data;
  var wave_icon = Props.wave_icon;
  var title = Props.title;
  var setCardsStyles = function (param) {
    if (services_cards_data.length === 1) {
      return styles["single-service-card-wrapper"];
    } else {
      return styles["services-cards-wrapper"];
    }
  };
  return React.createElement("div", {
              className: styles["our-services-section"]
            }, React.createElement(SectionHeading$PorterinFeature.make, {
                  title: title,
                  wave_icon: wave_icon
                }), React.createElement("div", {
                  className: styles["our-services-section-container"]
                }, React.createElement("div", {
                      className: setCardsStyles(undefined)
                    }, Belt_Array.mapWithIndex(services_cards_data, (function (index, service_card) {
                            return React.createElement(ServicesCardCmp$PorterinFeature.make, {
                                        content: service_card,
                                        index: index,
                                        key: String(index)
                                      });
                          })))));
}

var make = ServicesSectionCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
